import React from "react";
import { Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { useSavedPosit } from "@/hooks/useSavedPosit";

interface SaveStarProps {
  positId: string;
  disabled?: boolean;
  onChange?: (isSaved: boolean) => void;
}

const SaveStar: React.FC<SaveStarProps> = ({ positId, disabled, onChange }) => {
  const { isSaved, isLoading, toggle } = useSavedPosit(positId);

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            aria-label={isSaved ? "Unsave Posit" : "Save Posit"}
            title={isSaved ? "Unsave" : "Save"}
            variant="ghost"
            size="sm"
            className={`h-8 w-8 p-0 rounded-lg ${isSaved ? "text-blue-500" : "text-muted-foreground"}`}
            onClick={async () => {
              const result = await toggle();
              if (typeof result === 'boolean' && onChange) {
                onChange(!isSaved);
              }
            }}
            disabled={disabled || isLoading}
          >
            <Star className={`h-5 w-5 ${isSaved ? "fill-current" : ""}`} />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="top">{isSaved ? 'Unsave' : 'Save'}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default SaveStar;


